import { z } from 'zod';

import { defineStorageItem, STORAGE_KEY } from '@shared/lib/storage';

/**
 * 구 웹 리프레시 토큰(DD-88, 2027-01-31 까지 — 기한 뒤 이 파일을 지운다).
 * 구 웹은 같은 origin 의 `localStorage['session']` 에 문자열 그대로 두었다.
 * **새 서버 세션이 생기면(로그인 · 갱신 · 이어받기 · 대리) 지우고, 로그아웃 때도 지운다** —
 * 남겨 두면 로그아웃 뒤 새로 고침에서 그 토큰 주인으로 다시 이어받는다(공용 PC 면 다른 사람).
 */
export const legacySessionItem = defineStorageItem({
  key: STORAGE_KEY.LEGACY_SESSION,
  schema: z.string(),
  // 구 웹은 로그아웃 때 '' 를 넣기도 한다 — 빈 문자열은 없는 것으로 본다.
  fallback: '',
  raw: true,
});

/** 남은 구 토큰을 지운다(없으면 아무 일도 없다) */
export function clearLegacySession(): void {
  legacySessionItem.remove();
}
